// src/app/shared/modal/modal-builder-impl.ts
import { Injectable } from '@angular/core';
import { ImodalBuilder } from './Interfaces/imodal-builder';
import { ModalConfig } from './modal-config';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { iModalTitles } from './Interfaces/imodal-titles';
import { iHeaderButton } from './Interfaces/iheader-buttons';
import { ModalDimension } from './Interfaces/imodal-dimensions';
import { ModalOverflow } from './Interfaces/imodal-overflow-options';
import { ModalColor } from './Interfaces/imodal-colors';

@Injectable()
export class ModalBuilder implements ImodalBuilder {
    private config: ModalConfig = new ModalConfig();

    setTitle(title: iModalTitles): ImodalBuilder {
        this.config.title = title;
        return this;
    }

    showTitletHint(showHint:boolean): ImodalBuilder {
        this.config.showTitleHint = showHint;
        return this;
    }

    setTitleHint(hint:string): ImodalBuilder {
        this.config.titleHint = hint;
        return this;
    }

    setTitleHintColor(color:ModalColor): ImodalBuilder {
        this.config.titleHintColor = color;
        return this;
    }

    setWidth(width: ModalDimension): ImodalBuilder {
        this.config.width = width;
        return this;
    }
    
    setHeight(height: ModalDimension): ImodalBuilder {
        this.config.height = height;
        return this;
    }
    
    setBorderRadius(borderRadius: ModalDimension): ImodalBuilder {
        this.config.borderRadius = borderRadius;
        return this;
    }

    setHeaderEditBtn(button: iHeaderButton): ImodalBuilder {
        this.config.header_edit = button;
        return this;
    }

    setHeaderSaveBtn(button: iHeaderButton): ImodalBuilder {
        this.config.header_save = button;
        return this;
    }

    setFitContent(fitContent: boolean): ImodalBuilder {
        this.config.fitContent = fitContent;
        return this;
    }

    setHeaderActivatedBtn(button: iHeaderButton): ImodalBuilder {
        this.config.header_activate = button;
        return this;
    }
    setHeaderDeactivatedBtn(button: iHeaderButton): ImodalBuilder {
        this.config.header_deactivate = button;
        return this;
    }

    setHeaderBackgroundColor(color: ModalColor): ImodalBuilder {
        this.config.header_background_color = color;
        return this;
    }

    setHeaderTitleColor(color: ModalColor): ImodalBuilder {
        this.config.header_title_color = color;
        return this;
    }

    setHeaderBorderColor(color: ModalColor): ImodalBuilder {
        this.config.header_border_color = color;
        return this;
    }

    setBodyOverFlow(overflow: ModalOverflow): ImodalBuilder {
        this.config.overflow = overflow;
        return this;
    }

    setMode(mode: string): ImodalBuilder {
        this.config.mode = mode;
        return this;
    }

    setData(data: string): ImodalBuilder {
        this.config.data = data;
        return this;
    }

    setContent(content: string): ImodalBuilder {
        this.config.content = content;
        return this;
    }

    setActions(actions: { label: string; action: () => void }[]): ImodalBuilder {
        this.config.actions = actions;
        return this;
    }

    setFormFields(fields: { name: string; validators: any[]; translationKey: string }[]): ModalBuilder {
        const controls: { [key: string]: UntypedFormControl } = {};
        fields.forEach(field => {
            const control = new UntypedFormControl('', field.validators || []);
            // Attach metadata to control for translation keys
            (control as any).translationKey = field.translationKey;
            controls[field.name] = control;
        });
        this.config.formGroup = new UntypedFormGroup(controls);
        return this;
    }

    setShowFooter(showFooter:boolean): ImodalBuilder {
        this.config.show_footer = showFooter;
        return this;
    }


    build(): ModalConfig {
        return this.config;
    }
}
